import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import api from '../api';
import DataTable from '../components/DataTable';

const HARC_TURLERI = ['RUHSAT_HARCI','YENILEME_HARCI','DEVIR_HARCI','CEZA_HARCI','BASVURU_UCRETI','DIGER'];
const ODEME_YONTEMLERI = ['NAKIT','KREDI_KARTI','HAVALE','EFT','DIGER'];

export default function HarcTakip() {
  const { kullanici } = useContext(AuthContext);
  const navigate = useNavigate();
  const [veriler, setVeriler] = useState([]);
  const [istatistik, setIstatistik] = useState({ toplam:0, toplam_tutar:0, odenen:0 });
  const [yukleniyor, setYukleniyor] = useState(false);
  const [modalAcik, setModalAcik] = useState(false);
  const [odemeModal, setOdemeModal] = useState(null);
  const [filtre, setFiltre] = useState({ odendi:'', harc_turu:'', q:'' });
  const [form, setForm] = useState({ ruhsat_id:'', harc_turu:'RUHSAT_HARCI', aciklama:'', tutar:'', tahakkuk_tarihi:new Date().toISOString().split('T')[0] });
  const [odemeForm, setOdemeForm] = useState({ odeme_tarihi:new Date().toISOString().split('T')[0], makbuz_no:'', odeme_yontemi:'NAKIT' });
  const [ruhsatArama, setRuhsatArama] = useState('');
  const [ruhsatSonuc, setRuhsatSonuc] = useState([]);
  const yazabilir = ['admin','mudur','personel'].includes(kullanici?.rol);
  const mudurAdmin = ['admin','mudur'].includes(kullanici?.rol);

  useEffect(() => { yukle(); }, [filtre]); // eslint-disable-line

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const params = { limit:200 };
      if (filtre.odendi !== '') params.odendi = filtre.odendi;
      if (filtre.harc_turu) params.harc_turu = filtre.harc_turu;
      if (filtre.q) params.q = filtre.q;
      const p = new URLSearchParams(params);
      const r = await api.get(`/harc?${p}`);
      setVeriler(r.data.veriler||[]);
      setIstatistik({ toplam:r.data.toplam||0, toplam_tutar:r.data.toplam_tutar||0, odenen:r.data.odenen||0 });
    } finally { setYukleniyor(false); }
  };

  const ruhsatAra = async () => {
    if (!ruhsatArama) return;
    const r = await api.get(`/ruhsat?q=${ruhsatArama}&limit=10`);
    setRuhsatSonuc(r.data.veriler||[]);
  };

  const kaydet = async (e) => {
    e.preventDefault();
    try {
      await api.post('/harc', form);
      yukle(); setModalAcik(false); setForm({ ruhsat_id:'', harc_turu:'RUHSAT_HARCI', aciklama:'', tutar:'', tahakkuk_tarihi:new Date().toISOString().split('T')[0] }); setRuhsatArama(''); setRuhsatSonuc([]);
    } catch (err) { alert(err.response?.data?.hata||'Hata'); }
  };

  const odeKaydet = async (e) => {
    e.preventDefault();
    try {
      await api.patch(`/harc/${odemeModal.id}/ode`, odemeForm);
      yukle(); setOdemeModal(null);
    } catch (err) { alert(err.response?.data?.hata||'Hata'); }
  };

  const sil = async (id) => {
    if (!window.confirm('Bu harç kaydı silinecek. Onaylıyor musunuz?')) return;
    try { await api.delete(`/harc/${id}`); yukle(); } catch (err) { alert(err.response?.data?.hata||'Hata'); }
  };

  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '';
  const para = v => v ? Number(v).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})+' ₺' : '—';
  const odenmemis = istatistik.toplam_tutar - istatistik.odenen;

  const columns = [
    { key:'unvan', label:'İşyeri', render:(v,r)=>v?<span style={{fontSize:'12px'}}><strong>{v}</strong> <span style={{color:'#888'}}>({r.rn})</span></span>:<span style={{color:'#999',fontSize:'12px'}}>—</span>, exportValue:r=>r.unvan||'' },
    { key:'harc_turu', label:'Harç Türü', width:'130px', render:v=><span style={{fontSize:'11px',padding:'2px 8px',borderRadius:'10px',background:'#e3f2fd',color:'#1565c0'}}>{v?.replace(/_/g,' ')}</span> },
    { key:'aciklama', label:'Açıklama', render:v=><span style={{fontSize:'12px'}}>{v||'—'}</span> },
    { key:'tahakkuk_tarihi', label:'Tahakkuk', width:'100px', render:v=><span style={{fontSize:'12px'}}>{fmt(v)}</span>, exportValue:r=>fmt(r.tahakkuk_tarihi) },
    { key:'tutar', label:'Tutar', width:'110px', render:v=><span style={{fontSize:'13px',fontWeight:'700',color:'#1565c0'}}>{para(v)}</span>, exportValue:r=>Number(r.tutar||0).toFixed(2) },
    { key:'odendi', label:'Durum', width:'100px', render:v=>v?<span style={{fontSize:'11px',fontWeight:'700',color:'#1b5e20'}}>✅ ÖDENDİ</span>:<span style={{fontSize:'11px',fontWeight:'700',color:'#c62828'}}>⚠ BEKLYOR</span>, exportValue:r=>r.odendi?'Ödendi':'Bekliyor' },
    { key:'odeme_tarihi', label:'Ödeme Tar.', width:'100px', render:v=><span style={{fontSize:'12px',color:v?'#1b5e20':'#bbb'}}>{v?fmt(v):'—'}</span>, exportValue:r=>fmt(r.odeme_tarihi) },
    { key:'makbuz_no', label:'Makbuz No', width:'100px', render:v=><span style={{fontSize:'12px',fontFamily:'monospace'}}>{v||'—'}</span> },
    { key:'_islem', label:'İşlem', width:'130px', sortable:false, filterable:false,
      render:(_,r)=>(
        <div style={{display:'flex',gap:'4px'}}>
          {yazabilir&&!r.odendi&&<button className="btn btn-primary btn-xs" onClick={e=>{e.stopPropagation();setOdemeModal(r);setOdemeForm({odeme_tarihi:new Date().toISOString().split('T')[0],makbuz_no:'',odeme_yontemi:'NAKIT'});}}>💳 Öde</button>}
          {r.ruhsat_id&&<button className="btn btn-secondary btn-xs" onClick={e=>{e.stopPropagation();navigate(`/ruhsat/${r.ruhsat_id}`);}}>Ruhsat</button>}
          {mudurAdmin&&!r.odendi&&<button className="btn btn-danger btn-xs" onClick={e=>{e.stopPropagation();sil(r.id);}}>Sil</button>}
        </div>
      )
    },
  ];

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'20px'}}>
        <div>
          <h2 style={{color:'#1a237e',fontSize:'20px'}}>💰 Harç ve Ücret Takibi</h2>
          <div style={{fontSize:'12px',color:'#888',marginTop:'2px'}}>Dayanak: 2464 s.K. / İşyeri Ruhsat Yönetmeliği / Belediye Gelir Tarifesi</div>
        </div>
        {yazabilir&&<button className="btn btn-primary" onClick={()=>setModalAcik(true)}>➕ Harç Tahakkuk Ettir</button>}
      </div>

      {/* İstatistik kartları */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'16px',marginBottom:'20px'}}>
        <div className="stat-card" style={{background:'linear-gradient(135deg,#1565c0,#1e88e5)',color:'#fff',padding:'16px',borderRadius:'8px'}}>
          <div style={{fontSize:'12px',opacity:0.8}}>Toplam Tahakkuk</div>
          <div style={{fontSize:'20px',fontWeight:'700',marginTop:'4px'}}>{para(istatistik.toplam_tutar)}</div>
          <div style={{fontSize:'11px',opacity:0.7,marginTop:'4px'}}>{istatistik.toplam} kayıt</div>
        </div>
        <div className="stat-card" style={{background:'linear-gradient(135deg,#1b5e20,#388e3c)',color:'#fff',padding:'16px',borderRadius:'8px'}}>
          <div style={{fontSize:'12px',opacity:0.8}}>Tahsil Edilen</div>
          <div style={{fontSize:'20px',fontWeight:'700',marginTop:'4px'}}>{para(istatistik.odenen)}</div>
          <div style={{fontSize:'11px',opacity:0.7,marginTop:'4px'}}>{istatistik.toplam_tutar>0?((istatistik.odenen/istatistik.toplam_tutar)*100).toFixed(1):0}% tahsilat oranı</div>
        </div>
        <div className="stat-card" style={{background:'linear-gradient(135deg,#b71c1c,#e53935)',color:'#fff',padding:'16px',borderRadius:'8px'}}>
          <div style={{fontSize:'12px',opacity:0.8}}>Bekleyen / Ödenmemiş</div>
          <div style={{fontSize:'20px',fontWeight:'700',marginTop:'4px'}}>{para(odenmemis)}</div>
          <div style={{fontSize:'11px',opacity:0.7,marginTop:'4px'}}>{veriler.filter(v=>!v.odendi).length} bekleyen kayıt</div>
        </div>
      </div>

      <div className="card">
        <div className="search-bar">
          <input className="search-input" placeholder="🔍 İşyeri adı veya ruhsat no..." value={filtre.q} onChange={e=>setFiltre({...filtre,q:e.target.value})} />
          <select value={filtre.odendi} onChange={e=>setFiltre({...filtre,odendi:e.target.value})} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:'4px'}}>
            <option value="">Tüm Durumlar</option>
            <option value="false">Bekleyen</option>
            <option value="true">Ödenmiş</option>
          </select>
          <select value={filtre.harc_turu} onChange={e=>setFiltre({...filtre,harc_turu:e.target.value})} style={{padding:'8px 12px',border:'1px solid #ddd',borderRadius:'4px'}}>
            <option value="">Tüm Türler</option>
            {HARC_TURLERI.map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
          </select>
        </div>
        <DataTable columns={columns} data={veriler} filename="harc_takip" pdfTitle="Harç ve Ücret Takip Listesi" loading={yukleniyor} />
      </div>

      {/* Tahakkuk modal */}
      {modalAcik&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setModalAcik(false)}>
          <div className="modal" style={{maxWidth:'500px'}}>
            <div className="modal-header"><span className="modal-title">Harç Tahakkuk Ettir</span><button className="modal-close" onClick={()=>setModalAcik(false)}>×</button></div>
            <form onSubmit={kaydet}>
              <div className="form-grid">
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>İlgili İşyeri *</label>
                  <div style={{display:'flex',gap:'8px'}}>
                    <input value={ruhsatArama} onChange={e=>setRuhsatArama(e.target.value)} placeholder="Ruhsat no veya işyeri adı..." className="search-input" onKeyDown={e=>e.key==='Enter'&&(e.preventDefault(),ruhsatAra())} />
                    <button type="button" className="btn btn-outline" onClick={ruhsatAra}>Ara</button>
                  </div>
                  {ruhsatSonuc.length>0&&(
                    <div style={{border:'1px solid #ddd',borderRadius:'4px',marginTop:'4px',maxHeight:'150px',overflowY:'auto',background:'#fff'}}>
                      {ruhsatSonuc.map(r=>(
                        <div key={r.id} onClick={()=>{setForm(f=>({...f,ruhsat_id:r.id}));setRuhsatArama(`${r.rn} - ${r.unvan}`);setRuhsatSonuc([]);}}
                          style={{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #f0f0f0',fontSize:'13px'}}
                          onMouseOver={e=>e.currentTarget.style.background='#f5f5ff'} onMouseOut={e=>e.currentTarget.style.background='#fff'}>
                          <strong>{r.rn}</strong> — {r.unvan}
                        </div>
                      ))}
                    </div>
                  )}
                  {form.ruhsat_id&&<div style={{fontSize:'12px',color:'#1b5e20',marginTop:'4px'}}>✅ Seçildi <button type="button" style={{color:'#c62828',background:'none',border:'none',cursor:'pointer'}} onClick={()=>{setForm(f=>({...f,ruhsat_id:''}));setRuhsatArama('');}}>✕</button></div>}
                </div>
                <div className="form-group">
                  <label>Harç Türü *</label>
                  <select value={form.harc_turu} onChange={e=>setForm({...form,harc_turu:e.target.value})} required>
                    {HARC_TURLERI.map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Tutar (₺) *</label>
                  <input type="number" step="0.01" min="0" value={form.tutar} onChange={e=>setForm({...form,tutar:e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Tahakkuk Tarihi</label>
                  <input type="date" value={form.tahakkuk_tarihi} onChange={e=>setForm({...form,tahakkuk_tarihi:e.target.value})} />
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}><label>Açıklama</label><textarea value={form.aciklama} onChange={e=>setForm({...form,aciklama:e.target.value})} rows={2}/></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setModalAcik(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Tahakkuk Ettir</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Ödeme modal */}
      {odemeModal&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setOdemeModal(null)}>
          <div className="modal" style={{maxWidth:'420px'}}>
            <div className="modal-header"><span className="modal-title">Ödeme Kaydet</span><button className="modal-close" onClick={()=>setOdemeModal(null)}>×</button></div>
            <div style={{padding:'16px',background:'#f5f5f5',margin:'16px',borderRadius:'8px',fontSize:'13px'}}>
              <div><strong>İşyeri:</strong> {odemeModal.unvan}</div>
              <div><strong>Tür:</strong> {odemeModal.harc_turu?.replace(/_/g,' ')}</div>
              <div style={{fontSize:'18px',fontWeight:'700',color:'#1565c0',marginTop:'8px'}}>{para(odemeModal.tutar)}</div>
            </div>
            <form onSubmit={odeKaydet}>
              <div className="form-grid" style={{padding:'0 16px'}}>
                <div className="form-group">
                  <label>Ödeme Tarihi</label>
                  <input type="date" value={odemeForm.odeme_tarihi} onChange={e=>setOdemeForm({...odemeForm,odeme_tarihi:e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Makbuz No</label>
                  <input value={odemeForm.makbuz_no} onChange={e=>setOdemeForm({...odemeForm,makbuz_no:e.target.value})} placeholder="Makbuz / Tahsilat no..." />
                </div>
                <div className="form-group" style={{gridColumn:'1/-1'}}>
                  <label>Ödeme Yöntemi</label>
                  <select value={odemeForm.odeme_yontemi} onChange={e=>setOdemeForm({...odemeForm,odeme_yontemi:e.target.value})}>
                    {ODEME_YONTEMLERI.map(k=><option key={k} value={k}>{k.replace(/_/g,' ')}</option>)}
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setOdemeModal(null)}>İptal</button>
                <button type="submit" className="btn btn-primary">✅ Ödeme Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
